import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

const pick = (items) => items[Math.floor(Math.random() * items.length)];

export function generateTask() {
  const base = pick([2, 3, 5, 10]);
  const value = pick([1, 2, 3]);
  const argumentValue = base ** value;

  return {
    type: "LogNumberAsLogTask",
    data: {
      base,
      value,
      argumentValue,
      leftLatex: `${value}=\\log_{${base}} x`,
    },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <p>
        Zapisz liczbę <InlineMath math={String(data.value)} /> jako logarytm
        o podstawie <InlineMath math={String(data.base)} />. Podaj argument{" "}
        <InlineMath math="x" />:
      </p>
      <BlockMath math={data.leftLatex} />
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="x"
      placeholder="wpisz argument logarytmu"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return Number(userAnswer?.parsed) === data.argumentValue;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath
      math={`${data.value}=\\log_{${data.base}}${data.argumentValue}`}
    />
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer?.raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`x=${formatLatexPreview(userAnswer.raw)}`} />;
}

export function renderExplanation({ data }) {
  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1.</strong> Korzystamy z definicji logarytmu:
      </p>
      <BlockMath math="\log_a b=c\iff a^c=b" />
      <p>
        <strong>Krok 2.</strong> Liczbę stojącą przed znakiem równości
        traktujemy jako wartość logarytmu:
      </p>
      <BlockMath
        math={`${data.value}=\\log_{${data.base}}x
          \\iff x=${data.base}^{${data.value}}=${data.argumentValue}`}
      />
      <p>
        Tego samego kroku używamy, gdy łączymy liczbę i logarytm:
      </p>
      <BlockMath
        math={`${data.value}=\\log_{${data.base}}
          \\left(${data.base}^{${data.value}}\\right)`}
      />
    </div>
  );
}
